import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import ChevronIcon from "components/icons/chevron-icon";
import { COLORS } from "containers/impact-report/constants";

import {
  FaqSection,
  ContentWrapper,
  SectionTitle,
  FaqItem,
  QuestionButton,
  QuestionText,
  AnswerWrapper,
  AnswerText,
  AnswerList,
  AnswerLink,
  FooterLink
} from "./FaqAccordion.styled";

const FaqAccordion = () => {
  const { t } = useTranslation();
  const [openItems, setOpenItems] = useState([]);

  const faqItems = t("impactReport.faq.items", { returnObjects: true });

  const toggleItem = index => {
    setOpenItems(prev =>
      prev.includes(index)
        ? prev.filter(item => item !== index)
        : [...prev, index]
    );
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleItem(index);
    }
  };

  return (
    <FaqSection>
      <ContentWrapper>
        <SectionTitle>{t("impactReport.faq.sectionTitle")}</SectionTitle>
        {faqItems.map((item, index) => {
          const isOpen = openItems.includes(index);
          const itemId = `faq-item-${index}`;
          const answerId = `faq-answer-${index}`;

          return (
            <FaqItem key={index}>
              <QuestionButton
                onClick={() => toggleItem(index)}
                onKeyDown={e => handleKeyDown(e, index)}
                aria-expanded={isOpen}
                aria-controls={answerId}
                id={itemId}
              >
                <QuestionText>{item.question}</QuestionText>
                <ChevronIcon
                  direction={isOpen ? "up" : "down"}
                  size={24}
                  color={COLORS.PRIMARY_500}
                  fillOpacity={"1"}
                />
              </QuestionButton>
              <AnswerWrapper
                isOpen={isOpen}
                id={answerId}
                role={"region"}
                aria-labelledby={itemId}
              >
                {item.answer.map((paragraph, pIndex) => {
                  if (paragraph === "<list>") {
                    const listItems = item.listItems || [];
                    return (
                      <AnswerList key={pIndex}>
                        {listItems.map((listItem, liIndex) => (
                          <li key={liIndex}>{listItem}</li>
                        ))}
                      </AnswerList>
                    );
                  }

                  const links = item.links || [];
                  const linkComponents = links.map((url, linkIndex) => (
                    <AnswerLink
                      key={`link${linkIndex}`}
                      href={url}
                      target={"_blank"}
                      rel={"noopener noreferrer"}
                    />
                  ));

                  return (
                    <AnswerText key={pIndex}>
                      <Trans
                        i18nKey={`impactReport.faq.items.${index}.answer.${pIndex}`}
                        components={linkComponents}
                      />
                    </AnswerText>
                  );
                })}
              </AnswerWrapper>
            </FaqItem>
          );
        })}
        <FooterLink
          href={t("impactReport.faq.footerLink.url")}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          {t("impactReport.faq.footerLink.text")}
        </FooterLink>
      </ContentWrapper>
    </FaqSection>
  );
};

export default FaqAccordion;
